import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { Observable } from "rxjs";
import { ComponentCanDeactivate } from "../Models/interfaces/component-can-deactivate.interface";

@Injectable({
  providedIn: "root",
})
export class UnsavedChangesGuard
  implements CanDeactivate<ComponentCanDeactivate>
{
  async canDeactivate(component: ComponentCanDeactivate): Promise<boolean> {
    let canDeactivate = component.canDeactivate();
    if (
      (typeof canDeactivate == "boolean" && canDeactivate) ||
      ((canDeactivate as Promise<boolean>).then &&
        (await (canDeactivate as Promise<boolean>))) ||
      ((canDeactivate as Observable<boolean>).toPromise &&
        (await (canDeactivate as Observable<boolean>).toPromise()))
    ) {
      return true;
    } else {
      var result = confirm(
        "There are still unsaved changes in this survey. Press Cancel to go back and try to re-save the changes, or press Ok to lose these changes."
      );
      if (component.deactivate && result) component.deactivate();

      return result;
    }
  }
}
